import { sharedExtensionCards } from '../gameData/extensions.shared';
import { AnimalCard, SimplifiedExtensionCard } from '../types/ExtensionCard';

export const getWorkingExtensions = (
  animal: AnimalCard,
): SimplifiedExtensionCard[] => {
  const isEggLike = animal.extensions.some(
    (extension) => sharedExtensionCards[extension.type].isBlockingEverything,
  );
  if (isEggLike) {
    return [];
  }
  return animal.extensions.filter((extension) => !extension.isDisabledByTumor);
};
